export default __webpack_public_path__ + "alberta-pain-therapy.493dda6e519ac4a1f4de.svg";